<template>
  <div>
    <v-dialog v-model="showDialog" :width="1050">
      <v-container column class="feature-intro-container relative-position">
        <div class="close-icon-container">
          <v-icon
            color="#000000"
            size="20"
            @click="toggleDialog(false)"
            class="cursor-pointer"
            title="Close"
            >fas fa-times</v-icon
          >
        </div>
        <img :src="imgSrc" class="feature-image pr-4" alt="" />
        <div class="accepted-container">
          <v-checkbox
            v-model="accepted"
            label="Don't show this popup again"
            hide-details
            color="white"
            class="shrink mt-0 mr-3 pull-left hide-checkbox"
            @click="acceptWelcome"
          ></v-checkbox>
          <div class="clearfix"></div>
        </div>
      </v-container>
    </v-dialog>
  </div>
</template>

<script>
import { MODULE_PREFIX_USER } from "@/store";
import { mapGetters } from "vuex";
import { SAVE_PREFERENCES } from "@/store/actions.type";

export default {
  name: "FeatureIntroMessage",
  data: () => ({
    version: "v3", // This should change everytime new content is available for all users to show popup again.
    accepted: false,
    showDialog: false,
  }),
  mounted() {
    this.checkIfShow();
  },
  computed: {
    ...mapGetters({
      preferences: MODULE_PREFIX_USER + "preferences",
    }),
    imgSrc() {
      return require("@/assets/images/seerist-feature-popup.png");
    },
  },
  methods: {
    checkIfShow() {
      if (
        !this.preferences?.showFeatureIntroMessage ||
        this.preferences?.showFeatureIntroMessage != this.version
      ) {
        this.showDialog = true;
      }
    },
    acceptWelcome(val) {
      this.accepted = val;
      if (!this.accepted) {
        return false;
      }
      this.setPrefs();
      this.showDialog = false;
    },
    setPrefs() {
      if (this.preferences) {
        this.preferences.showFeatureIntroMessage = this.version;
        this.preferences.force = true;
        this.$store.dispatch(
          MODULE_PREFIX_USER + SAVE_PREFERENCES,
          this.preferences
        );
      }
    },
    toggleDialog(val) {
      this.showDialog = val;
    },
  },
};
</script>

<style scoped>
.hide-checkbox .v-label {
  font-size: 14px !important;
}
.feature-intro-container {
  background-color: #ffffff;
}
.feature-image {
  width: 100%;
}
.close-icon-container {
  position: absolute;
  right: 10px;
  top: 10px;
  z-index: 2;
}
</style>
